import { useContext } from "react";
import { InstallPromptContext } from "./InstallPromptContext";
import { isIOS } from "./detectPlatform";

import {
  Slide,
  Paper,
  Typography,
  Button,
  Box,
  IconButton
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

export default function InstallPromptBar({ visible }) {
  const {
    deferredPrompt,
    showInstallUI,
    dismiss,
  } = useContext(InstallPromptContext);

  if (!showInstallUI || !visible) return null;

  const handleInstall = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();
    const result = await deferredPrompt.userChoice;

    if (result.outcome === "accepted") {
      console.log("PWA instalado");
    } else {
      console.log("PWA instalação recusada");
    }

    dismiss();
  };

  const isIosDevice = isIOS();

  return (
    <Slide in={true} direction="down">
      <Paper
        elevation={4}
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 2000,
          borderRadius: 0,
          background: "#ffffffcc",
          backdropFilter: "blur(8px)",
          p: 2,
          display: "flex",
          flexDirection: "column",
          gap: 1,
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="subtitle1" fontWeight={600}>
            Adicionar à tela inicial?
          </Typography>
          <IconButton size="small" onClick={dismiss}>
            <CloseIcon />
          </IconButton>
        </Box>

        {isIosDevice ? (
          <Typography variant="body2">
            Para instalar, toque no botão <strong>Compartilhar</strong> e escolha
            <strong> "Adicionar à Tela de Início"</strong>.
          </Typography>
        ) : (
          <>
            <Typography variant="body2">
              Instale o app +Opção para acesso mais rápido e melhor experiência.
            </Typography>
            <Button
              variant="contained"
              size="small"
              onClick={handleInstall}
              sx={{ mt: 1, borderRadius: 2 }}
            >
              Instalar
            </Button>
          </>
        )}

        <Button
          variant="text"
          size="small"
          onClick={dismiss}
          sx={{ mt: 1 }}
        >
          Agora não
        </Button>
      </Paper>
    </Slide>
  );
}
